import type { KanbanAgent } from '@entities/task'

import { useAdminRoutes } from '@shared/lib/routes'

import { useTutorKanbanStore } from '../model/store'

export const useAgentsApi = async (): Promise<KanbanAgent[]> => {
  const { $axios } = useNuxtApp()

  const url = useAdminRoutes('admin.agents')

  const tutorKanbanStore = useTutorKanbanStore()

  try {
    const { data } = await $axios.get(url!)
    const agents: KanbanAgent[] = data.data.agents

    tutorKanbanStore.setAgents(agents)

    return agents
  } catch (err: unknown) {
    console.error(err)

    return []
  }
}
